import React from 'react';
import { useLocation } from 'react-router-dom';
import EnhancedPatientList from '../components/EnhancedPatientList';
import MainLayout from '../components/MainLayout';

const PatientList = ({ onEditDoctor }) => {
  const location = useLocation();
  const isNewPatient = location.pathname === '/patients/new';

  return (
    <MainLayout onEditDoctor={onEditDoctor}>
      <EnhancedPatientList showNewPatientForm={isNewPatient} />
    </MainLayout>
  );
};

export default PatientList;
